module.exports = __webpack_public_path__ + "static/media/workwear.5ef0b6c1.svg";